export default __webpack_public_path__ + "static/media/detail_big_12_4.22019926.jpg";